<div data-test="O_TPb1Nm" class="text-container"></div>

<ng-container *ngIf="files && files?.length">
  <h2 data-test="iaQX9EEW">Attachments</h2>
  <ul data-test="8WoGEmua">
    <li data-test="5d5QnBvx" *ngFor="let file of files">
      <a data-test="jtsgnBIF" [href]="imagesPath + file.file" [download]="file.name">
        {{ file.name }}
      </a>
    </li>
  </ul>
</ng-container>
